import styled from 'styled-components';

const size = '50px';

export default styled.img`
  float: left;
  max-width: ${size};
  max-height: ${size};
  grid-area: image;
  align-self: center;
  justify-self: center;
`;
